import { IPayment, IPayoutInfluencer } from "../types/briefCampains";

export function getBankVerificationLink(
  record: IPayoutInfluencer | IPayment
): string | null {
  return record.bankVerificationLink || null;
}
